var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list-group"},_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,class:['list-group-item', _vm.selectedItem.locationCode == item.locationCode ? 'selected' : ''],on:{"click":function($event){return _vm.idcSelect(item)}}},[_c('p',[_vm._v(_vm._s(item.locationName))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }